import styled from '@emotion/styled'
import { Image } from 'app/components/Common/Image'
import { FlexBox } from 'app/components/Layout/FlexBox'
import { styles } from 'app/theme'
import { useVocabularyData } from 'app/utils/vocabulary'
import React, { memo } from 'react'

export interface Props {
  languageCode: string
}

export const Brands = memo(function Brands({ languageCode }: Props) {
  return (
    <Container row space="between" wrap>
      <Box>
        <Label>{useVocabularyData('brand', languageCode)}</Label>
        <Anchor target="_blank" href="https://www.petruccihotels.com">
          <ImageWrap>
            <Image alt="Hotels" src="/petrucci-hotels.webp" />
          </ImageWrap>
          <Title>Petrucci Hotels</Title>
        </Anchor>

        <Anchor target="_blank" href="https://www.ristorantepetrucci.it">
          <ImageWrap>
            <Image alt="Ristorante" src="/ristorante-petrucci.webp" />
          </ImageWrap>
          <Title>Ristorante Petrucci</Title>
        </Anchor>
      </Box>
    </Container>
  )
})

const Container = styled(FlexBox)`
  @media (max-width: 1199px) {
    width: 100%;
  }
`

const Box = styled.div`
  ${styles.description.dark}

  &:first-of-type {
    margin-left: 0;
  }

  @media (max-width: 1199px) {
    width: 100%;
    margin-left: 0;
    display: flex;
    flex-wrap: wrap;
    gap: 0.75rem;
    justify-content: center;
  }
`

const Label = styled.div`
  ${styles.title.small}

  margin-bottom: 1.25rem;

  @media (max-width: 1199px) {
    width: 100%;
    margin-bottom: 0;
  }
`

const Anchor = styled.a`
  display: block;
  color: ${({ theme }) => theme.colors.variants.neutralDark3};
  margin-bottom: 1.25rem;
  transition: all 0.3s ease-in-out;

  &:last-of-type {
    margin-bottom: 1.25rem;
  }

  @media (min-width: 1200px) {
    &:hover {
      div:last-of-type {
        opacity: 0.5;
      }
      img {
        transform: scale(1.1);
      }
    }
  }

  img {
    ${styles.img}
    transition: all 0.3s ease-in-out;
  }

  @media (max-width: 1199px) {
    width: calc(50% - 0.375rem);
    margin-bottom: 0;

    &:last-of-type {
      margin-bottom: 0;
    }
  }
`

const ImageWrap = styled.div`
  position: relative;
  aspect-ratio: 3.375;
  height: 4.5rem;
  overflow: hidden;

  @media (max-width: 1199px) {
    width: 100%;
    position: relative;
    height: auto;
    min-height: 4.5rem;
  }
`

const Title = styled.div`
  ${styles.description.dark}

  color: ${({ theme }) => theme.colors.variants.neutralDark2};
  font-size: 0.875rem;
  line-height: 1rem;
  margin-top: 0.5rem;
  transition: 0.2s cubic-bezier(0.25, 1, 0.5, 1);
`
